"use client";

import S from "./index.module.scss";
import SuccessCard from "./card";
import { SUCCESS_LIST } from "../../constants/people";

const SuccessList = () => {
  return (
    <div className={S.wrapper}>
      <div className={S.borderWrap}>
        <div className={S.grid}>
          {SUCCESS_LIST.map(item => (
            <SuccessCard key={item.slug} item={item} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default SuccessList;
